import React from "react";
import classnames from "classnames";

import Container from "./Container";

const TitleContainer = ({ title = "", children, className, containerClassName = "", bodyClassName = "", ...otherProps }) => {
    return (
        <Container
            className={containerClassName}
        >
            <div
                className={classnames(className, "space-y-8 divide-y divide-gray-200 bg-white shadow rounded-md")}
                {...otherProps}
            >
                <div className="divide-y divide-gray-200">
                    <div>
                        <h3 className="text-lg leading-6 p-6 font-medium text-gray-900">
                            {title}
                        </h3>
                    </div>
                    <div className={classnames("p-6", bodyClassName)}>
                        {children}
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default TitleContainer;
